import { Button } from '@/components/ui/button';
import { ArrowUpDown, ChevronUp, ChevronDown } from 'lucide-react';

export type SortDir = 'asc' | 'desc';

interface SortableHeaderProps {
  label: string;
  field: string;
  currentField: string;
  currentDir: SortDir;
  onSort: (field: string) => void;
  className?: string;
}

export function SortableHeader({ label, field, currentField, currentDir, onSort, className }: SortableHeaderProps) {
  const isActive = currentField === field;
  return (
    <Button
      variant="ghost"
      size="sm"
      className={`h-auto p-0 font-medium ${className ?? ''}`}
      onClick={() => onSort(field)}
    >
      {label}
      {isActive
        ? (currentDir === 'asc'
            ? <ChevronUp className="ml-1 h-4 w-4 inline stroke-[3]" />
            : <ChevronDown className="ml-1 h-4 w-4 inline stroke-[3]" />)
        : <ArrowUpDown className="ml-1 h-4 w-4 inline opacity-40 stroke-[2.5]" />}
    </Button>
  );
}
